import React from 'react'
import GenericGrid from '../../sharedcomponents/5templates/commonGrid/GenericGrid'
import GridWrapper from '../../sharedcomponents/5templates/commonGrid/GridWrapper'
import useGridWrapper from '../../sharedcomponents/5templates/commonGrid/useGridWrapper'
import useGroup from './useGroup'

const UserGroups = () => {
  const defaultFetchParameter = {
    include: ['counts'],
    sort: '+name',
    type: 'user',
    page: 0,
    per_page: 20
  }
  const {
    loadGroups,
    bulkUpdateGroupsCallBack,
    typeIdToDisplayName,
    groupTypes
  } = useGroup()

  const {
    editMode,
    setEditMode,
    isSnackbarOpen,
    setIsSnackbarOpen,
    deletionChanges,
    deleteCallBack,
    addCallBack,
    activationChanges,
    activationCallBack,
    detailCallBack,
    handSaveCallback,
    isGridDirty
  } = useGridWrapper('Territory Group', bulkUpdateGroupsCallBack)

  const visibleColumns = [
    { field: 'name', headerName: 'Name', width: 200, sortable: true },
    {
      field: 'description',
      headerName: 'Description',
      width: 300,
      sortable: true
    },
    {
      field: 'total_user',
      headerName: 'Users',
      width: 150,
      sortable: true
    },
    {
      field: 'active',
      headerName: 'Status',
      width: 150,
      sortable: true,
      isToggle: true
    }
  ]

  const fetchCallBack = async arg => {
    const {
      data: { data, pagination, sort } = {
        data: [],
        pagination: {},
        sort: {}
      },
      isError,
      isLoading,
      isFetching
    } = await loadGroups(arg)

    // transform the server-provided array for display
    const rows = []
    data.forEach(one => {
      rows.push({
        id: one.id, //please note, the underlying datagrid assumes the id column is always called id
        name: one.name,
        type_id: one.type_id,
        type: one.type,
        description: one.description,
        total_user: one.stats.find(r => r.type === 'user').count,
        active: one.suspended_at ? false : true,
        is_system: one.is_system
      })
    })

    return {
      newRows: rows,
      newPagination: pagination,
      newSort: sort,
      newLoading: isLoading || isFetching,
      newError: isError
    }
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div style={{ height: '100%', width: '100%' }}>
        <GridWrapper
          header={'User Groups'}
          editMode={editMode}
          setEditMode={setEditMode}
          isSnackbarOpen={isSnackbarOpen}
          setIsSnackbarOpen={setIsSnackbarOpen}
          isGridDirty={isGridDirty}
          addCallBack={addCallBack}
          listOfTypes={groupTypes}
          typeToTypeDisplayName={typeIdToDisplayName}
          handleSave={handSaveCallback}
          containedEntityType={'user'}
        >
          <GenericGrid
            initialFetchParameters={defaultFetchParameter}
            visibleColumns={visibleColumns}
            editMode={editMode}
            fetchCallBack={fetchCallBack}
            detailCallBack={detailCallBack}
            deleteCallBack={deleteCallBack}
            activationCallBack={activationCallBack}
            deletionChanges={deletionChanges}
            activationChanges={activationChanges}
          />
        </GridWrapper>
      </div>
    </div>
  )
}
export default React.memo(UserGroups)
